import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

const rootEl = document.getElementById("root")!;

try {
  const { AuthProvider } = await import("./auth/AuthContext");
  const { default: App } = await import("./App");

  createRoot(rootEl).render(
    <StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </StrictMode>
  );
} catch (err) {
  rootEl.innerHTML = `<pre style="padding:2rem;color:#b91c1c;background:#fef2f2;white-space:pre-wrap;font-family:monospace;">STARTUP ERROR:\n\n${err instanceof Error ? (err.stack ?? err.message) : String(err)}</pre>`;
  console.error("Startup error:", err);
}

const chatbotRootEl = document.getElementById("chatbot-root");
if (chatbotRootEl) {
  try {
    const { default: ChatbotWidget } = await import("./chatbot/ChatbotWidget");
    createRoot(chatbotRootEl).render(
      <StrictMode>
        <ChatbotWidget />
      </StrictMode>
    );
  } catch (err) {
    console.error("Chatbot widget startup error:", err);
  }
}
